import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { getLatestNews, formatDate } from '@/lib/queries';

export default function NewsPreview() {
  const list = getLatestNews(3);

  return (
    <section className="border-y border-background-800/70 bg-background-900/40">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="Industry news"
          title="影视资讯推荐"
          description="行业观察、新片速递、片场手记与榜单数据，四个栏目持续更新日韩影视圈的动态与幕后。"
          linkTo="/news"
          linkLabel="全部资讯"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {list.map((article, index) => (
            <Link
              key={article.id}
              to={`/news/${article.id}`}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-800 bg-background-900 transition-colors hover:border-primary-600"
            >
              <div className="relative h-[180px] w-full overflow-hidden bg-background-800 md:h-[200px]">
                <img
                  src={article.cover}
                  alt={`${article.title} 配图`}
                  title={`${article.title} - 日韩成人电影资讯`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent" />
                <span className="absolute left-3 top-3 rounded bg-background-950/80 px-2 py-1 text-[11px] text-accent-400 backdrop-blur-sm">
                  {article.section}
                </span>
                {index === 0 && (
                  <span className="absolute right-3 top-3 rounded bg-primary-500 px-2 py-1 text-[11px] text-background-50">
                    最新
                  </span>
                )}
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center gap-2 text-[11px] text-foreground-600">
                  <span className="font-label tracking-[0.12em]">{formatDate(article.date)}</span>
                  <span className="h-2.5 w-px bg-background-700" />
                  <span className="truncate">{article.author}</span>
                </div>
                <h3 className="mt-2.5 text-sm font-semibold leading-relaxed text-foreground-100 transition-colors group-hover:text-accent-400 md:text-[15px]">
                  {article.title}
                </h3>
                <p className="mt-2 line-clamp-3 flex-1 text-xs leading-relaxed text-foreground-500">{article.summary}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-[11px] text-foreground-400 transition-colors group-hover:text-accent-400">
                  阅读全文
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}